module.exports = __webpack_public_path__ + "assets/653b1d2212edc2123dc5895f2bab0a43.mp4";